import { mapState } from 'vuex';
export const mixins = {
    computed: {
        ...mapState({
            currentPrivileges: (state, getters) => state.identity.privileges,
            isAdmin: (state, getters) => state.identity.isAdmin,
            isBTCUser: (state, getters) => true, //state.identity.isBTCUser,
            userUnitId: (state, getters) => state.identity.unitId,
            userUnitName: (state, getters) => state.identity.unitName
        })
    },
    methods: {
        authorize(requiredPrivileges, unitId) {
            if (this.isAdmin) return true;

            var result = intersect(this.currentPrivileges, requiredPrivileges).length > 0;

            //if (unitId) {
            //    result = result && this.$store.state.identity.manageUnitIds.indexOf(unitId) != -1;
            //}

            return result;
        },
        getSyncSourceTypeCache(options, excluded, included) {
            var result = window.localStorage.getItem(`tsc:${this.$store.state.identity.username}-syncDataSourceId`);
            if (isNaN(result)) {
                return null; 
            } else {
                if (options && options.indexOf(parseInt(result)) == -1) return null;
                if (excluded && excluded.indexOf(parseInt(result)) != -1) return null;
                if (included && included.indexOf(parseInt(result)) == -1) return null;
                return result;
            }
        },
        getUnitTreeIdCache(syncSourceType) {
            return window.localStorage.getItem(`tsc:${this.$store.state.identity.username}-${syncSourceType}-unitTreeId`);
        },
        getUnitTreeTraversalOptionCache() {
            var result = parseInt(window.localStorage.getItem(`tsc:${this.$store.state.identity.username}-unitTreeTraversalOption`));
            if (isNaN(result)) {
                return null;
            } else {
                return result;
            }
        },
        getTopLevelUnitIdCache() {
            var id = window.localStorage.getItem(`tsc:topLevelUnitId`);

            if (this.$store.state.common.topLevelUnits.find(x => x.id == id)) {
                return id;
            } else {
                return null;
            }
        }
    }
};
